export const introduce = {
  text: '交易所钱包净持仓变化（流入/流出）',
  height: 1200,
};
